// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27 viewBox=%270 0 24 24%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M20.707 6.293a1 1 0 0 1 0 1.414l-8.586 8.586a3 3 0 0 1-4.243 0l-3.586-3.586a1 1 0 0 1 1.414-1.414l3.586 3.586a1 1 0 0 0 1.414 0l8.586-8.586a1 1 0 0 1 1.414 0z%27 fill=%27%23b5e4ca%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msl8UQL44bh0bLEVSJAV {
  margin-bottom: 12px;
}
@media only screen and (max-width: 767px) {
  .msl8UQL44bh0bLEVSJAV {
    font-size: 24px;
  }
}

.d1OzMuu8YRUpjNDMXgEf {
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: -0.02em;
  color: #6F767E;
}
@media only screen and (max-width: 767px) {
  .d1OzMuu8YRUpjNDMXgEf {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767px) {
  .d1OzMuu8YRUpjNDMXgEf {
    font-size: 14px;
  }
}

.xirQukPNS4J6N0vtkTds {
  display: flex;
  align-items: center;
}

.Oi1KLPNe4W0appOD2xwk {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #6F767E;
}
.Oi1KLPNe4W0appOD2xwk span {
  margin-left: 4px;
  color: #1A1D1F;
}
.dark-mode .Oi1KLPNe4W0appOD2xwk span {
  color: #FCFCFC;
}

.EFjzV6b16v_D08KwtkQg {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-right: 12px;
}
.EFjzV6b16v_D08KwtkQg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.R3eUqa6bWm4rEtfGEXwP {
  display: flex;
  align-items: center;
  margin-left: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
}
.R3eUqa6bWm4rEtfGEXwP svg {
  margin-right: 8px;
  fill: #FFC554;
}

.TqDqfYMQ3_xt_Wlpq0S0 {
  margin-left: 4px;
  color: #6F767E;
}

.ebHYLRK6Xlu1j1tMpGFv {
  position: relative;
  margin-top: 40px;
}
@media only screen and (max-width: 767px) {
  .ebHYLRK6Xlu1j1tMpGFv {
    margin-top: 32px;
  }
}
.ebHYLRK6Xlu1j1tMpGFv .NNhLc_DfblWzbhYrJHvU {
  position: absolute;
  left: 12px;
  bottom: 12px;
}
@media only screen and (max-width: 767px) {
  .ebHYLRK6Xlu1j1tMpGFv .NNhLc_DfblWzbhYrJHvU {
    bottom: 5px;
  }
}
.dark-mode .ebHYLRK6Xlu1j1tMpGFv .NNhLc_DfblWzbhYrJHvU {
  box-shadow: inset 0 0 0 2px #272B30;
  background: #1A1D1F;
  color: #FCFCFC;
}
.dark-mode .ebHYLRK6Xlu1j1tMpGFv .NNhLc_DfblWzbhYrJHvU:hover {
  background: #272B30;
}

.s36Odw06m11MC3G0djzV img {
  width: 100%;
  border-radius: 12px;
}

.QNcyPtUavePD6qXi1Ja6 {
  display: flex;
  margin-top: 40px;
}
@media only screen and (max-width: 1023px) {
  .QNcyPtUavePD6qXi1Ja6 {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .QNcyPtUavePD6qXi1Ja6 {
    margin-top: 32px;
  }
}

.lAtPSsU7_zsDWf_R28UW:first-child {
  flex-grow: 1;
  padding-right: 64px;
}
@media only screen and (max-width: 1259px) {
  .lAtPSsU7_zsDWf_R28UW:first-child {
    padding-right: 48px;
  }
}
@media only screen and (max-width: 1023px) {
  .lAtPSsU7_zsDWf_R28UW:first-child {
    padding-right: 0;
  }
}
.lAtPSsU7_zsDWf_R28UW:nth-child(2) {
  flex-shrink: 0;
  width: 308px;
}
@media only screen and (max-width: 1023px) {
  .lAtPSsU7_zsDWf_R28UW:nth-child(2) {
    width: 100%;
    margin-top: 32px;
  }
}

.pcXtRe1DSZ3v5LKTgclY {
  margin-bottom: 32px;
}
@media only screen and (max-width: 1023px) {
  .pcXtRe1DSZ3v5LKTgclY {
    margin-bottom: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .pcXtRe1DSZ3v5LKTgclY {
    margin-bottom: 12px;
  }
}

.iRZWQYCNc7pTmHsLkJWH {
  font-weight: 500;
  color: #33383F;
}
.dark-mode .iRZWQYCNc7pTmHsLkJWH {
  color: #EFEFEF;
}

.iRZWQYCNc7pTmHsLkJWH p:not(:last-child) {
  margin-bottom: 16px;
}

@media only screen and (max-width: 767px) {
  .jvb48VeD_CFQJpIMuvCp {
    margin-top: 12px;
  }
}
.jvb48VeD_CFQJpIMuvCp li {
  position: relative;
  padding-left: 40px;
  color: #33383F;
}
.dark-mode .jvb48VeD_CFQJpIMuvCp li {
  color: #EFEFEF;
}

.jvb48VeD_CFQJpIMuvCp li:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/100% auto;
}
.jvb48VeD_CFQJpIMuvCp li:not(:last-child) {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EFEFEF;
}
@media only screen and (max-width: 767px) {
  .jvb48VeD_CFQJpIMuvCp li:not(:last-child) {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
}
.dark-mode .jvb48VeD_CFQJpIMuvCp li:not(:last-child) {
  border-color: #272B30;
}`, "",{"version":3,"sources":["webpack://./src/components/ModalProduct/Product/Details/Overview/Overview.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ;ACcI;EDdJ;IAGQ,eAAA;EACN;AACF;;AAAA;EACI,mBAAA;ECyDA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ED1DA,cCkCC;AD5BL;ACAI;EDTJ;IC+DQ,eAAA;EDlDN;AACF;ACLI;EDTJ;IAKQ,eAAA;EAaN;AACF;;AAZA;EACI,aAAA;EACA,mBAAA;AAeJ;;AAbA;EACI,aAAA;EACA,mBAAA;ECoEA,eAAA;EACA,gBAAA;EACA,yBAAA;EDpEA,cCsBC;ADJL;AAjBI;EACI,gBAAA;EACA,cCsBH;ADHL;ACgJa;EDjKD,cCcP;ADML;;AAlBA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAqBJ;AApBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAsBR;;AApBA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EC6CA,eAAA;EACA,gBAAA;EACA,yBAAA;ADrBJ;AAxBI;EACI,iBAAA;EACA,aAAA;AA0BR;;AAxBA;EACI,gBAAA;EACA,cCPC;ADkCL;;AAzBA;EACI,kBAAA;EACA,gBAAA;AA4BJ;ACnEI;EDqCJ;IAIQ,gBAAA;EA8BN;AACF;AA9BI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAgCR;AC7EI;ED0CA;IAKQ,WAAA;EAkCV;AACF;AC0Fa;ED3HD,mCAAA;EACA,mBCnBP;EDoBO,cC1BP;AD8DL;AAnCY;EACI,mBCvBX;AD4DL;;AAlCI;EACI,WAAA;EACA,mBAAA;AAqCR;;AAnCA;EACI,aAAA;EACA,gBAAA;AAsCJ;ACvGI;ED+DJ;IAIQ,cAAA;EAwCN;AACF;ACzGI;ED4DJ;IAMQ,gBAAA;EA2CN;AACF;;AAzCI;EACI,YAAA;EACA,mBAAA;AA4CR;ACzHI;ED2EA;IAIQ,mBAAA;EA8CV;AACF;AC3HI;EDwEA;IAMQ,gBAAA;EAiDV;AACF;AAjDI;EACI,cAAA;EACA,YAAA;AAmDR;ACpII;ED+EA;IAIQ,WAAA;IACA,gBAAA;EAqDV;AACF;;AApDA;EACI,mBAAA;AAuDJ;AC9II;EDsFJ;IAGQ,mBAAA;EAyDN;AACF;AChJI;EDmFJ;IAKQ,mBAAA;EA4DN;AACF;;AA3DA;EACI,gBAAA;EACA,cC/DC;AD6HL;ACkBa;ED9EL,cCnEH;ADkIL;;AA7DQ;EACI,mBAAA;AAgEZ;;ACjKI;EDmGJ;IAEQ,gBAAA;EAiEN;AACF;AAjEI;EACI,kBAAA;EACA,kBAAA;EACA,cC5EH;AD+IL;ACAa;EDjED,cChFP;ADoJL;;AAnEQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+EAAA;AAsEZ;AArEQ;EACI,mBAAA;EACA,oBAAA;EACA,gCAAA;AAuEZ;AC9LI;EDoHI;IAKQ,mBAAA;IACA,oBAAA;EAyEd;AACF;ACxBa;EDhDG,qBC9FX;ADyKL","sourcesContent":["@import ../../../../../styles/helpers\n\n.title\n    margin-bottom: 12px\n    +m\n        font-size: 24px\n\n.info\n    margin-bottom: 12px\n    +title1-m\n    color: $n4\n    +m\n        font-size: 14px\n\n.line\n    display: flex\n    align-items: center\n\n.author\n    display: flex\n    align-items: center\n    +base2\n    color: $n4\n    span\n        margin-left: 4px\n        color: $n7\n        +dark\n            color: $n1\n\n.avatar\n    flex-shrink: 0\n    width: 32px\n    height: 32px\n    margin-right: 12px\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n        border-radius: 50%\n\n.rating\n    display: flex\n    align-items: center\n    margin-left: 12px\n    +base2\n    svg\n        margin-right: 8px\n        fill: #FFC554\n\n.counter\n    margin-left: 4px\n    color: $n4\n\n.gallery\n    position: relative\n    margin-top: 40px\n    +m\n        margin-top: 32px\n    .button\n        position: absolute\n        left: 12px\n        bottom: 12px\n        +m\n            bottom: 5px\n        +dark\n            box-shadow: inset 0 0 0 2px $n6\n            background: $n7\n            color: $n1\n            &:hover\n                background: $n6\n\n.preview\n    img\n        width: 100%\n        border-radius: 12px\n\n.row\n    display: flex\n    margin-top: 40px\n    +t\n        display: block\n    +m\n        margin-top: 32px\n\n.col\n    &:first-child\n        flex-grow: 1\n        padding-right: 64px\n        +d\n            padding-right: 48px\n        +t\n            padding-right: 0\n    &:nth-child(2)\n        flex-shrink: 0\n        width: 308px\n        +t\n            width: 100%\n            margin-top: 32px\n\n.subtitle\n    margin-bottom: 32px\n    +t\n        margin-bottom: 24px\n    +m\n        margin-bottom: 12px\n\n.content\n    font-weight: 500\n    color: $n5\n    +dark\n        color: $n3\n    p\n        &:not(:last-child)\n            margin-bottom: 16px\n\n.features\n    +m\n        margin-top: 12px\n    li\n        position: relative\n        padding-left: 40px\n        color: $n5\n        +dark\n            color: $n3\n        &:before\n            content: \"\"\n            position: absolute\n            top: 0\n            left: 0\n            width: 24px\n            height: 24px\n            background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill-rule='evenodd' d='M20.707 6.293a1 1 0 0 1 0 1.414l-8.586 8.586a3 3 0 0 1-4.243 0l-3.586-3.586a1 1 0 0 1 1.414-1.414l3.586 3.586a1 1 0 0 0 1.414 0l8.586-8.586a1 1 0 0 1 1.414 0z' fill='%23b5e4ca'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto\n        &:not(:last-child)\n            margin-bottom: 20px\n            padding-bottom: 20px\n            border-bottom: 1px solid $n3\n            +m\n                margin-bottom: 16px\n                padding-bottom: 16px\n            +dark\n                border-color: $n6","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `msl8UQL44bh0bLEVSJAV`,
	"info": `d1OzMuu8YRUpjNDMXgEf`,
	"line": `xirQukPNS4J6N0vtkTds`,
	"author": `Oi1KLPNe4W0appOD2xwk`,
	"avatar": `EFjzV6b16v_D08KwtkQg`,
	"rating": `R3eUqa6bWm4rEtfGEXwP`,
	"counter": `TqDqfYMQ3_xt_Wlpq0S0`,
	"gallery": `ebHYLRK6Xlu1j1tMpGFv`,
	"button": `NNhLc_DfblWzbhYrJHvU`,
	"preview": `s36Odw06m11MC3G0djzV`,
	"row": `QNcyPtUavePD6qXi1Ja6`,
	"col": `lAtPSsU7_zsDWf_R28UW`,
	"subtitle": `pcXtRe1DSZ3v5LKTgclY`,
	"content": `iRZWQYCNc7pTmHsLkJWH`,
	"features": `jvb48VeD_CFQJpIMuvCp`
};
export default ___CSS_LOADER_EXPORT___;
